export const ALGOLIA_APP_ID = process.env.GATSBY_ALGOLIA_APP_ID;
export const ALGOLIA_SEARCH_KEY = process.env.GATSBY_ALGOLIA_SEARCH_KEY;
